import {atom, DefaultValue, selector} from "recoil";
import { ExpiredActionProps, PracticesListSummaryReturn, RecoveryCompany } from "./models/models";

export const expiredManagementState = atom({
    key: 'expiredManagementState',
    default: {
        filterParams: null,
        practiceDetail: null,
        practiceActionHistory: null,
        attachmentsType: [],
        recoveryEntrustmentDetail: null,
        recoveryCompanies: []
    }
})

export const filterParams = selector<any>({
    key: 'filterParamsState',
    get: ({ get }) => get(expiredManagementState).filterParams,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            filterParams: newValue instanceof DefaultValue ? get(expiredManagementState).filterParams : newValue
        })
    }
});

export const practiceDetail = selector<any>({
    key: 'practiceDetailState',
    get: ({ get }) => get(expiredManagementState).practiceDetail,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            practiceDetail: newValue instanceof DefaultValue ? get(expiredManagementState).practiceDetail : newValue
        })
    }
});

export const practiceActionHistory = selector<any>({
    key: 'practiceActionHistoryState',
    get: ({ get }) => get(expiredManagementState).practiceActionHistory,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            practiceActionHistory: newValue instanceof DefaultValue ? get(expiredManagementState).practiceActionHistory : newValue
        })
    }
});

export const recoveryEntrustmentDetailState = selector<any>({
    key: 'recoveryEntrustmentDetail',
    get: ({ get }) => get(expiredManagementState).recoveryEntrustmentDetail,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            recoveryEntrustmentDetail: newValue instanceof DefaultValue ? get(expiredManagementState).recoveryEntrustmentDetail : newValue
        })
    }
});

export const recoveryCompaniesState = selector<any>({
    key: 'recoveryCompanies',
    get: ({ get }) => get(expiredManagementState).recoveryCompanies,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            recoveryCompanies: newValue instanceof DefaultValue ? get(expiredManagementState).recoveryCompanies : newValue
        })
    }
});

export const attachmentsTypeState = selector<any>({
    key: 'attachmentsTypeState',
    get: ({ get }) => get(expiredManagementState).attachmentsType,
    set: ({ set, get }, newValue) => {
        set(expiredManagementState, {
            ...get(expiredManagementState),
            attachmentsType: newValue instanceof DefaultValue ? get(expiredManagementState).attachmentsType : newValue
        })
    }
});

export const practicesListSummaryState = atom<PracticesListSummaryReturn['summary'] | undefined>({
    key: 'practicesListSummaryState',
    default: undefined
})

export const selectedPracticesListState = atom<any[] | [] | null>({
    key: 'selectedPracticesListState',
    default: null
})

export const expiredActionPropsState = atom<ExpiredActionProps | null>({
    key: 'expiredActionPropsState',
    default: null
})

export const recoveryCompanyOptionsState = atom<RecoveryCompany[] | []>({
    key: 'recoveryCompanyOptionsState',
    default: []
})

export const avaiableExpiredActionsState = atom<string[] | []>({
    key: 'avaiableExpiredActionsState',
    default: []
})

export const excludedExpiredRecoveratorAttachmentState = atom<string[]>({
    key: 'excludedExpiredRecoveratorAttachmentState',
    default: []
})
